// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2y78w","header":"ReportDetails_header__1qi73","title":"ReportDetails_title__2n_Fh","left":"ReportDetails_left__ij2K8"};